import { jsxs, jsx } from 'react/jsx-runtime';
import { useTheme as useTheme$1, ThemeProvider as ThemeProvider$1 } from '@lemonade-hq/cdk';
import { GlobalStylesheet } from '../styles/global.esm.js';
import { DEFAULT_THEME, themes } from '../styles/theme.esm.js';

var useTheme = function() {
    return useTheme$1();
};
var ThemeProvider = function(param) {
    var children = param.children, _param_themeName = param.themeName, themeName = _param_themeName === void 0 ? DEFAULT_THEME.name : _param_themeName, overrides = param.overrides, _param_includeGlobalStyles = param.includeGlobalStyles, includeGlobalStyles = _param_includeGlobalStyles === void 0 ? true : _param_includeGlobalStyles;
    var parentTheme = useTheme();
    var isRootTheme = parentTheme == null;
    return /*#__PURE__*/ jsxs(ThemeProvider$1, {
        overrides: overrides,
        themeName: themeName,
        themes: themes,
        children: [
            isRootTheme && includeGlobalStyles && /*#__PURE__*/ jsx(GlobalStylesheet, {}),
            children
        ]
    });
};

export { ThemeProvider, useTheme };
